module.exports = __webpack_public_path__ + "assets/img/car27.7083f1a0.png";